var items = [{
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list01.jpg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list01.jpg-square',
    state: "hide"
}, {
    desc: "大量描述自动折行，限制两行，自动省略号。大量描述自动折行，限制两行，自动省略号。大量描述自动折行，限制两行，自动省略号。",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list02.jpg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list02.jpg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list03.jpg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list03.jpg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list04.JPG-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list04.JPG-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list05.JPG-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list05.JPG-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list06.jpeg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list06.jpeg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list07.jpeg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list07.jpeg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list08.jpg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list08.jpg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list10.jpg-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list10.jpg-square',
    state: "hide"
}, {
    desc: "This is a lazy item.",
    smallSrc: 'http://oenqoxl4h.bkt.clouddn.com/list09.png-small',
    bigSrc: 'http://oenqoxl4h.bkt.clouddn.com/list09.png-square',
    state: "hide"
}];

export default items;



/** WEBPACK FOOTER **
 ** ./data/items.js
 **/